import React, {useEffect, useState} from "react";
import { useTheme } from "../contexts/theme";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import MatchboardContent from "../components/MatchboardContent/MatchboardContent";
import {SportImagesDict} from "../utils/constants"
import '../index.css'
import axios from "../queries/axiosInstance";
import PageContainer from "../components/CommonComponents/PageContainer/PageContainer";
import {DataSource} from "../types/dataSourceTypes";
import {LoadError, SupportedSports} from "../types/generic";
import ErrorSnackBar from "../components/CommonComponents/ErrorSnackBar/ErrorSnackBar";
import {EventData} from "../types/eventTypes";
import SpinnerBox from "../components/CommonComponents/SpinnerBox/SpinnerBox";
import {getJobGroupByEvent, startJob, stopJob} from "../queries/jobQueries";
import {useSSEProvider} from "../contexts/SSEProvider";

interface Match {
    title: string;
    matchDate: string;
    sharedWith: string[];
    jobMatch: JobMatch[];
    [key: string]: any;
}

interface JobMatch {
    id: string,
    name: string,
    description: string,
    extraction_schedule: string,
    status: string,
    source: string,
    target: string,
    tag: string[],
    settings: boolean,
    away_team: string,
    home_team: string,
    key_moment_type: string,
    score: string,
    half: string,
    last_event_time: string,
    last_run: string,
    numberClips: number,
    redCard: number,

}

interface PageData {
    [league: string]: {match: Match[]};
}

interface OptionsFormEVent {
    optionsTag: string[];
    protocol: string[];
    typeMediaTrack: string[];
    typeOfFile: string[];
    containerType: string[];
    typeEvent: "football";
    typeProviderDataFeed: string[];
    feedSourcesTypes: string [];
    feed_type: string[];

}

interface OptionsJobForm {
    dataSources: DataSource[];
    optionsTag: string[];
    targetJob: string[];
    idEvent: string;
}




const Matchboard = () => {
    const {openSSE} = useSSEProvider();
    const theme  = useTheme();
    const [pageData, setPageData] = useState<PageData | undefined>(undefined);
    const [optionsforNewEvent, setOptionsforNewEvent] = useState<OptionsFormEVent>();
    const [idEventForNewJob, setIdEventForNewJob] = useState<string>("");
    const [idUpdateEvent, setIdUpdateEvent] = useState<string>("");
    const [loadError, setLoadError] = useState<LoadError>({error: false, message: ''});
    const [firstLoading, setFirstLoading] = useState<boolean>(false)

    const [tempEntity, setTempEntity] = useState<EventData>(
        {
            name: '',
            tags: [],
            description: '',
            away_team: '',
            home_team: '',
            season: '',
            typeEvent: "football",
            event_start: new Date(),
            event_end: new Date(),
            championship: '',
            venue: '',
            championship_name: "",
            dataSource: [{
                name: '',
                description: '',
                type: ''

            }]
        }
    );

    const [OptionsJobForm, setOptionsJobForm] = useState<OptionsJobForm>({
            dataSources: [{
                name: "",
                type: "",
                description: "",
            },],

            optionsTag: [],
            targetJob: [],
            idEvent: "",
        }

    );
/*
    const fetchDatas = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_BASE_URL + '/match/all' || '');
            return response.data;
        } catch (error) {
            console.error("Failed to fetch data:", error);
            return undefined;
        }
    }

    useEffect(() => {
        const getData = async () => {
            const data = await fetchDatas();
            setPageData(data);
        };
        getData().then(r => {});
    }, []);

 */

    const fetchEvent = async () => {
        try {
            return await getJobGroupByEvent()
        } catch (error) {
            console.error("Failed to fetch data:", error);
            return undefined;
        }
    }

    const getData = async () => {
        const data = await fetchEvent();
        setPageData(data);

        setPageData((prevData)=>{
            const updatedData: PageData = {};

            for (const leagueName in prevData){
                const league = prevData[leagueName];

                const updatedMatches = league.match.map((match, index) => ({

                    title: match.title,
                    matchDate: match.matchDate,
                    sharedWith: match.sharedWith,
                    competition: match.competition,
                    competition_id: match.competition_id,
                    // score: match.score,
                    // half: match.half,
                    // last_event_time: match.last_event_time,
                    // last_run: match.last_run,
                    // clips: match.numberClip,
                    // redCards: match.redCards,
                    id: match.id,
                    jobMatch: match.jobMatch,
                    jobs: match.jobs,
                    // status: match.jobMatch[match.jobMatch.length - 1] !== undefined ? match.jobMatch[match.jobMatch.length - 1].status : "ND",
                    // source: match.jobMatch[match.jobMatch.length - 1] !== undefined ? match.jobMatch[match.jobMatch.length - 1].source : "ND",



                }));




                updatedData[leagueName] = { match: updatedMatches };
            }
            return updatedData

        })
    };

    useEffect(() => {

        const intervalTime = 15000;


        setFirstLoading(true)
        getData().then(r => setFirstLoading(false));

       /*const pollingInterval = setInterval(()=>{
          getData().then();
        }, intervalTime)

        return () => clearInterval(pollingInterval);*/

    }, []);


    const onJobsRefresh = () => {
        setFirstLoading(true)
        getData().then(r => setFirstLoading(false));
    }




    const fetchOptionsforNewJob= async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_BASE_URL + `/match/optionsJob/${idEventForNewJob}`);
            return response.data;
        }catch (error) {
            console.error("Failed to fetch data:", error);
            return undefined;
        }
    }

    const handleOptionJobForm = (value: OptionsJobForm) => {
        setOptionsJobForm(value);
    }


     const deleteMatch = async (id: string) => {

         let found: boolean = false;

         for (const league in pageData) {
             if (!found) {
                 const matches = pageData[league].match;

                 for (const match of matches) {
                     if (match.id === id) {
                         for (const job of match.jobMatch) {
                             if (job.status === "Running" || job.status === "Starting") {
                                 found = true;
                             }

                         }
                     }
                 }
             }
         }


         try {
             if (!found) {
                 const response = await axios.delete(process.env.REACT_APP_BASE_URL + `/match/deleteEvent/${id}`);
             } else{
                 setLoadError({error: true, message: "Unable to delete the job"});
             }
         }catch (error) {
             console.error("Failed to delete data:", error);
             setLoadError({error: true, message: "Unable to delete the job"});
         }
     }




const fetchEventByID = async (id : string) => {
        try {
            const response = await axios.get(process.env.REACT_APP_BASE_URL + `/match/getEventById/${id}`);
            return response.data;
        }catch (error){
            console.error("Failed to fetch data:", error);
        }
    }

    const updateMatch = async (id: string) => {

        await fetchEventByID(id);

        try {
            const response= await axios.put(process.env.REACT_APP_BASE_URL + `/match/deleteEvent/${id}`,tempEntity);
        }catch (error) {
            console.error("Failed to delete data:", error);
        }
    }

    const handleIdEventForNewJob = (id: string) => {
        setIdEventForNewJob(id);
    }





    const handleGetEventForUpdateByID = async (id: string): Promise<EventData> => {
        try {
            const entity = await fetchEventByID(id);
            setTempEntity(entity);
            return entity;
        } catch (error) {
            console.error("Errore nel recupero dell'evento:", error);
            throw error;
        }
    };




    const manageJob = async (idJob: string, operation: string) => {

        try {
            if (operation === "Run") {
                return await startJob(idJob)
            }else if (operation === "Stop") {
                return await stopJob(idJob)
            }

        } catch (error) {
            console.error("Failed to fetch data:", error);
        }
    }

    const handleManageJob =  (idJob: string, operation: string) => {
        manageJob(idJob, operation).then(r =>{});
    }

    useEffect(() => {
        openSSE()
    }, []);



    return (
        <PageContainer>
            <Box
                style={{
                    width: "100%",
                    height: "100%",
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    backgroundColor: theme.palette.blue
                }}
            >

                <Box style={{borderRadius: theme.border.radius.md}}>
                    <ErrorSnackBar autoHideDuration={5000} open={loadError.error} setClose={() => setLoadError({message:'', error: false})} errorMessage={loadError.message}/>
                </Box>


                    <Grid container direction="column" style={{ height: '100%' }}>

                    {/* Main Content */}
                    <Grid item xs={12} sm={10} md={10} lg={8} style={{
                        paddingTop: theme.spacing.none,
                        paddingBottom: theme.spacing.none,
                        flex: 1,
                        color: theme.palette.white,
                        width: '100%',
                        overflowY: "scroll",
                        backgroundImage: `url(${SportImagesDict.Matchboard[process.env.REACT_APP_SPORT as SupportedSports]})`,
                        backgroundSize: 'contain',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                    }}
                          className="matchboardContent">
                        {!firstLoading ?
                            <MatchboardContent
                                deleteMatch={deleteMatch}
                                updateMatch={updateMatch}
                                handleGetEventForUpdateByID={handleGetEventForUpdateByID}
                                handleIdEventForNewJob={handleIdEventForNewJob}
                                optionsjobForm={OptionsJobForm}
                                pageData={pageData}
                                options={optionsforNewEvent}
                                setPageData={setPageData}
                                handleManageJob={handleManageJob}
                                handleOptionJobForm={handleOptionJobForm}
                                onJobRefresh={onJobsRefresh}
                            />:
                            <SpinnerBox
                                spinnerSize={50}
                                height={'80vh'}
                                text={''}
                            />
                        }
                    </Grid>
                </Grid>
            </Box>
        </PageContainer>
    );
}

export default Matchboard;
